import { Layer } from "../../framework/layer/Layer";
import { generateTypedId } from "../../util/IdUtils";
;
export class ActionClient extends Layer {
    constructor(gameContext, actionCreator, actionResultDeleter, actionValidatorBuilderMap) {
        super([]);
        this.pendingActions = Object.create(null);
        this.localCreatedActionIds = new Set();
        this.gameContext = gameContext;
        this.actionCreator = actionCreator;
        this.actionResultDeleter = actionResultDeleter;
        this.actionValidatorBuilderMap = actionValidatorBuilderMap;
    }
    activate() {
    }
    close() {
    }
    getLayerData() {
        return null;
    }
    update(inEvent) {
        var _a, _b, _c;
        if (inEvent.type !== 'Created') {
            return null;
        }
        const actionResult = inEvent.newData;
        const actionRenderer = this.pendingActions[actionResult.id];
        if (actionRenderer !== undefined) {
            if (actionResult.committed) {
                (_a = actionRenderer.onSuccess) === null || _a === void 0 ? void 0 : _a.call(actionRenderer);
            }
            else {
                (_b = actionRenderer.invalidFeedback) === null || _b === void 0 ? void 0 : _b.call(actionRenderer, actionResult.failureReason);
                (_c = actionRenderer.onFailure) === null || _c === void 0 ? void 0 : _c.call(actionRenderer);
            }
            delete this.pendingActions[actionResult.id];
            // TODO: Determine if this is actually needed anymore.
            // const hashCode = action!.getHashCode();
            // if (hashCode != '') {
            //     this.localCreatedActionHashCodes.delete(hashCode);
            // }
        }
        this.actionResultDeleter.deleteActionResult(actionResult.id);
        this.localCreatedActionIds.delete(actionResult.id);
        return null;
    }
    createReplicatedAction(className, dataInput, renderer = {}) {
        var _a, _b;
        const validator = this.actionValidatorBuilderMap[className];
        const contextData = this.gameContext.data;
        const actionId = this.getActionId();
        const data = Object.assign(Object.assign({}, dataInput), { className, id: actionId });
        const isValid = validator(data, contextData);
        // const hashCode = action.getHashCode();
        // if (game.replicatedActionClient.localCreatedActionHashCodes.has(hashCode) || ....
        if (typeof (isValid) === 'string' || !isValid) {
            (_a = renderer.invalidFeedback) === null || _a === void 0 ? void 0 : _a.call(renderer, typeof (isValid) === 'string' ? isValid : '');
            return;
        }
        this.localCreatedActionIds.add(data.id);
        this.actionCreator.createReplicatedAction(className, data);
        this.pendingActions[data.id] = renderer;
        (_b = renderer.onInit) === null || _b === void 0 ? void 0 : _b.call(renderer);
    }
    getActionId() {
        const playerId = this.gameContext.data.playerId;
        let typedId = generateTypedId('a', playerId);
        while (this.localCreatedActionIds.has(typedId)) {
            typedId = generateTypedId('a', playerId);
        }
        return typedId;
    }
}
//# sourceMappingURL=ActionClient.js.map